import { useQuery } from '@tanstack/react-query';
import { lpdDb } from '../lib/supabase-lpd';
import { useAuth } from '@/hooks/useAuth';
import type { LaadpleinDesign } from '../types/laadplein';

// `as any` op tabelnaam: Supabase types.ts is V1-locked en bevat de nieuwe laadplein_designs nog niet
export function useLaadpleinDesign(id: string | undefined) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['laadplein_designs', id],
    queryFn: async (): Promise<LaadpleinDesign | null> => {
      if (!id) return null;
      const { data, error } = await lpdDb
        .from('laadplein_designs')
        .select('*')
        .eq('id', id)
        .maybeSingle();
      if (error) throw error;
      return (data as LaadpleinDesign | null) ?? null;
    },
    enabled: !!user && !!id,
  });
}
